export default "__VITE_ASSET__29a48157__"